enum modalTypes {
  WARNING = "WARNING",
  ALERT = "ALERT",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

enum sizes {
  SM = "SM",
  LG = "LG",
}

enum actionLayout {
  START = "start",
  CENTER = "center",
  END = "end",
  STRETCHED = "stretched",
}

export { modalTypes, sizes, actionLayout };
